export { default as ExpenseTable } from './ExpenseTable';
export type { Props as ExpenseTableProps } from './ExpenseTable';
